import { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@garnish/constants';
import { BodyText } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────

export const NotificationPreferencesSubtitle = (props: PropsWithChildren) => {
  const { children } = props;

  return (
    <BodyText sizeMatch={['16']} style={styles.subtitle}>
      {children}
    </BodyText>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  subtitle: {
    color: theme.colors.CHARCOAL,
  },
});
